"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAnalysisStatus = exports.FileAnalysisType = void 0;
var FileAnalysisType;
(function (FileAnalysisType) {
    FileAnalysisType["IMAGE_DESCRIPTION"] = "IMAGE_DESCRIPTION";
    FileAnalysisType["AD_CREATIVE_DESCRIPTION"] = "AD_CREATIVE_DESCRIPTION";
    FileAnalysisType["VIDEO_DESCRIPTION"] = "VIDEO_DESCRIPTION";
    FileAnalysisType["DOCUMENT_CONTENT_EXTRACTION"] = "DOCUMENT_CONTENT_EXTRACTION";
})(FileAnalysisType || (exports.FileAnalysisType = FileAnalysisType = {}));
var FileAnalysisStatus;
(function (FileAnalysisStatus) {
    FileAnalysisStatus["PENDING"] = "PENDING";
    FileAnalysisStatus["PROCESSING"] = "PROCESSING";
    FileAnalysisStatus["COMPLETED"] = "COMPLETED";
    FileAnalysisStatus["FAILED"] = "FAILED";
})(FileAnalysisStatus || (exports.FileAnalysisStatus = FileAnalysisStatus = {}));
